import { createMuiTheme } from '@material-ui/core/styles';

const Theme = createMuiTheme({
  palette: {
    primary: {
      main: '#24ae4d'
    },
    secondary: {
      main: '#950000'
    },
  }
});

export default Theme;
